module.exports = __webpack_public_path__ + "static/media/IMG_0540.6c0b4b12.JPG";